import React from 'react';
import { isSupabaseConfigured } from '@/lib/supabase';
import { AlertTriangle } from 'lucide-react';

interface AuthConfigBannerProps {
  page?: 'login' | 'pricing' | 'generic';
}

export function AuthConfigBanner({ page = 'generic' }: AuthConfigBannerProps) {
  const configured = isSupabaseConfigured();
  if (configured) return null;

  const messageMap: Record<string, string> = {
    login: 'Authentication is not configured. Sign-in may be disabled on this environment.',
    pricing: 'Authentication is not configured. Upgrades require sign-in and may not work here.',
    generic: 'Authentication is not configured for this environment.',
  };

  const text = messageMap[page] || messageMap.generic;

  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-amber-900">
        <AlertTriangle className="h-4 w-4 flex-shrink-0" />
        <p className="text-sm">
          {text} Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your deployment.
        </p>
      </div>
    </div>
  );
}

